import React from 'react';
import { Field } from 'redux-form';
import NumberFormat from 'react-number-format';
import {
    renderFieldNumeros,
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    tamanhoPorcentagem,
    validateHora,
    validateMinutos,
} from '../../util/inputs';
import { tipoAjusteItinerario } from '../../util/constantsUtil';

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

const renderFieldHoraLocal = ({
    input,
    label,
    css,
    max,
    readOnly,
    meta: { touched, error },
}) => (
    <div>
        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>{label}</label>
        <NumberFormat
            {...input}
            format="##:##"
            className={css}
            maxLength={max}
            style={{ borderColor: touched && error ? 'red' : '' }}
            readOnly={readOnly}
        />
        {touched && error && <span style={{ color: 'red', fontSize: 11 }}>{error}</span>}
    </div>
);

const mostrarCampoHora = (config) => config && config.value === 'DATA_PARTIDA';

const mostrarCampoQuantidadePoltronas = (config) =>
    config && (
        config.value === 'POLTRONAS_VENDIDAS_A_CADA' ||
        config.value === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
        config.value === 'POLTRONAS_VENDIDAS_ATE_NUMERO'
    );

const ItemList = ({ items, renderLabel, onRemover }) => (
    <div className="vx-item-list" style={{ marginTop: 12 }}>
        {!items || items.length === 0
            ? <div className="vx-item-list-empty">Nenhum item cadastrado</div>
            : items.map((item, i) => (
                <div key={i} className="vx-item-list-item">
                    <div className="vx-item-list-item-info">
                        {renderLabel(item)}
                    </div>
                    <button type="button" className="vx-item-list-remove" onClick={() => onRemover(item)}>
                        <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                    </button>
                </div>
            ))
        }
    </div>
);

const FieldsetConfiguracaoPreco = ({
    exibirAjuste,
    exibirAjustePrioritario,
    exibirAjustePorCategoria,
    exibeTipoCategoriaUnica,
    tipoConfiguracaoPreco,
    quantidadePoltronasRegra,
    tipoConfiguracaoPrecoPrioritario,
    quantidadePoltronasRegraPrioritario,
    tiposConfiguracoesPreco,
    tiposConfiguracoesPrecoPrioritario,
    tiposConfiguracoesPrecoCategoria,
    usuariosVendedores,
    vendedoresSelecionados,
    tiposPreco,
    categoriasSelecionadas,
    onToggleAjuste,
    onToggleAjustePrioritario,
    onToggleAjustePorCategoria,
    onAdicionarPricePorUsuario,
    onRemoverUsuarioVendedor,
    onAdicionarPricePorCategoria,
    onRemoverCategoriaSelecionada,
}) => (
    <>
        {/* ── Ajuste Geral ── */}
        <SectionCard icon="percent" title="Configuração de Preço" subtitle="Desconto ou acréscimo geral nas passagens">
            <div className="vx-toggle-row">
                <div className="vx-toggle-info">
                    <div className="vx-toggle-info-title">Desconto / Acréscimo</div>
                    <div className="vx-toggle-info-desc">Adiciona um ajuste de preço nas passagens deste itinerário</div>
                </div>
                <Field name="exibirAjuste" type="checkbox" component={renderToggle} onChange={onToggleAjuste} />
            </div>

            {exibirAjuste && (
                <div style={{ marginTop: 12 }}>
                    <div className="vx-preco-fields-grid">
                        <Field
                            name="tipoAjusteItinerario"
                            options={tipoAjusteItinerario.map(e => ({ descricao: e.label, nome: e.value }))}
                            component={renderFieldSelect}
                            label="Desconto / Acréscimo"
                            placeholder="Selecione um tipo"
                            validate={requiredSelect}
                            menuPortalTarget={document.body}
                        />
                        <Field
                            name="valorAjuste"
                            validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            css="form-control"
                            label="Valor (%):"
                        />
                        <Field
                            name="tipoConfiguracaoPreco"
                            options={tiposConfiguracoesPreco.map(e => ({ descricao: e.label, nome: e.value }))}
                            component={renderFieldSelect}
                            label="Regra de ajuste"
                            validate={requiredSelect}
                            menuPortalTarget={document.body}
                        />
                    </div>
                    {mostrarCampoHora(tipoConfiguracaoPreco) && (
                        <div style={{ maxWidth: 160, marginTop: 8 }}>
                            <Field name="horaPartidaRegra" css="form-control" component={renderFieldHoraLocal}
                                label="Hora" validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]} />
                        </div>
                    )}
                    {mostrarCampoQuantidadePoltronas(tipoConfiguracaoPreco) && (
                        <div style={{ maxWidth: 200, marginTop: 8 }}>
                            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Número de poltronas</label>
                            <Field name="quantidadePoltronasRegra" type="text"
                                component={renderFieldNumeros}
                                valor={quantidadePoltronasRegra}
                                formatacao="##"
                                css="form-control"
                            />
                        </div>
                    )}
                </div>
            )}
        </SectionCard>

        {/* ── Ajuste por Categoria + Por Usuário ── */}
        <div className={!exibeTipoCategoriaUnica ? 'vx-config-grid' : ''}>

            {/* Por Categoria (condicional – categoria mista) */}
            {!exibeTipoCategoriaUnica && (
                <SectionCard icon="category" title="Preço por Categoria" subtitle="Ajuste por tipo de serviço">
                    <div className="vx-toggle-row">
                        <div className="vx-toggle-info">
                            <div className="vx-toggle-info-title">Desconto / Acréscimo</div>
                            <div className="vx-toggle-info-desc">Aplicar ajuste por tipo de serviço</div>
                        </div>
                        <Field name="exibirAjustePorCategoria" type="checkbox" component={renderToggle} onChange={onToggleAjustePorCategoria} />
                    </div>

                    {exibirAjustePorCategoria && (
                        <div style={{ marginTop: 12 }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                <Field name="tipoAjusteCategoria"
                                    options={tipoAjusteItinerario.map(e => ({ descricao: e.label, nome: e.value }))}
                                    component={renderFieldSelect}
                                    label="Desconto / Acréscimo"
                                    placeholder="Selecione"
                                    menuPortalTarget={document.body}
                                />
                                <Field name="valorAjusteCategoria"
                                    component={renderFieldNumerosPorcentagem}
                                    css="form-control"
                                    label="Valor (%):"
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 10, marginTop: 8 }}>
                                <Field name="tipoConfiguracaoPrecoCategoria"
                                    options={tiposConfiguracoesPrecoCategoria.map(e => ({ descricao: e.label, nome: e.value }))}
                                    component={renderFieldSelect}
                                    label="Regra de ajuste"
                                    menuPortalTarget={document.body}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 8, alignItems: 'end', marginTop: 8 }}>
                                <Field name="tipoPrecoCategoria"
                                    options={tiposPreco ? tiposPreco.map(e => ({ descricao: e.descricaoTipoPreco, nome: e.tipoPreco })) : []}
                                    component={renderFieldSelect}
                                    label="Tipo de Serviço"
                                    placeholder="Selecione o tipo"
                                    menuPortalTarget={document.body}
                                />
                                <button type="button" className="vx-btn-incluir" onClick={onAdicionarPricePorCategoria}>
                                    <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
                                </button>
                            </div>
                            <ItemList
                                items={categoriasSelecionadas}
                                onRemover={item => onRemoverCategoriaSelecionada(item.tipoPreco)}
                                renderLabel={item => (
                                    <>
                                        <span className="vx-item-list-item-label">{item.descricao}</span>
                                        <span className="vx-item-list-item-sub">{item.tipoAjusteItinerario && item.tipoAjusteItinerario.label} · {item.valorAjuste}%</span>
                                    </>
                                )}
                            />
                        </div>
                    )}
                </SectionCard>
            )}

            {/* Por Usuário */}
            <SectionCard icon="person" title="Preço por Usuário" subtitle="Ajuste individual por vendedor">
                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Desconto / Acréscimo</div>
                        <div className="vx-toggle-info-desc">Aplicar ajuste específico por vendedor</div>
                    </div>
                    <Field name="exibirAjustePrioritario" type="checkbox" component={renderToggle} onChange={onToggleAjustePrioritario} />
                </div>

                {exibirAjustePrioritario && (
                    <div style={{ marginTop: 12 }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                            <Field name="tipoAjusteItinerarioPrioritario"
                                options={tipoAjusteItinerario.map(e => ({ descricao: e.label, nome: e.value }))}
                                component={renderFieldSelect}
                                label="Desconto / Acréscimo"
                                placeholder="Selecione"
                                menuPortalTarget={document.body}
                            />
                            <Field name="valorAjustePrioritario"
                                component={renderFieldNumerosPorcentagem}
                                css="form-control"
                                label="Valor (%):"
                            />
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Field name="tipoConfiguracaoPrecoPrioritario"
                                options={tiposConfiguracoesPrecoPrioritario.map(e => ({ descricao: e.label, nome: e.value }))}
                                component={renderFieldSelect}
                                label="Regra de ajuste"
                                validate={requiredSelect}
                                menuPortalTarget={document.body}
                            />
                        </div>
                        {mostrarCampoHora(tipoConfiguracaoPrecoPrioritario) && (
                            <div style={{ maxWidth: 160, marginTop: 8 }}>
                                <Field name="horaPartidaRegraPrioritario" css="form-control"
                                    component={renderFieldHoraLocal} label="Hora"
                                    validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]} />
                            </div>
                        )}
                        {mostrarCampoQuantidadePoltronas(tipoConfiguracaoPrecoPrioritario) && (
                            <div style={{ maxWidth: 200, marginTop: 8 }}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Número de poltronas</label>
                                <Field name="quantidadePoltronasRegraPrioritario" type="text"
                                    component={renderFieldNumeros}
                                    valor={quantidadePoltronasRegraPrioritario}
                                    formatacao="##"
                                    css="form-control"
                                />
                            </div>
                        )}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 8, alignItems: 'end', marginTop: 8 }}>
                            <Field name="vendedores"
                                options={usuariosVendedores.map(e => ({ descricao: e.valor, nome: e.chave }))}
                                component={renderFieldSelect}
                                label="Usuário Vendedor"
                                placeholder="Selecione um usuário"
                                menuPortalTarget={document.body}
                            />
                            <button type="button" className="vx-btn-incluir" onClick={onAdicionarPricePorUsuario}>
                                <i className="material-icons" style={{ fontSize: 14 }}>add</i> Incluir
                            </button>
                        </div>
                        <ItemList
                            items={vendedoresSelecionados}
                            onRemover={item => onRemoverUsuarioVendedor(item.id)}
                            renderLabel={item => (
                                <>
                                    <span className="vx-item-list-item-label">{item.vendedor && item.vendedor.label}</span>
                                    <span className="vx-item-list-item-sub">{item.tipoAjusteItinerario && item.tipoAjusteItinerario.label} · {item.valorAjuste}%</span>
                                </>
                            )}
                        />
                    </div>
                )}
            </SectionCard>
        </div>
    </>
);

export default FieldsetConfiguracaoPreco;
